import { render } from "./BuildUpdate.vue?vue&type=template&id=bbf61826"
import script from "./BuildUpdate.vue?vue&type=script&lang=js"
export * from "./BuildUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__